import type React from "react";
import { memo } from "react";
import type { SearchResultContentProps } from "@/features/study-group-stream/utils/streamSearchResultTypes";
import { SearchResultItemList } from "@/features/study-group-stream/components/StreamSearchResultItems";
import { StreamSearchLoadMoreButton } from "@/features/study-group-stream/components/StreamSearchLoadMore";

export type { SearchResultContentProps };

const SearchResultContentRaw: React.FC<SearchResultContentProps> = ({
  streamContents,
  searchMatchStates,
  groupContext,
  unknownAuthorText,
  onPostReaction,
  reactingPosts,
  canLoadMore,
  isLoading,
  label,
  loadingLabel,
  onLoadMore,
  disabled,
}) => (
  <>
    <SearchResultItemList
      streamContents={streamContents}
      searchMatchStates={searchMatchStates}
      groupContext={groupContext}
      unknownAuthorText={unknownAuthorText}
      onPostReaction={onPostReaction}
      reactingPosts={reactingPosts}
    />
    {canLoadMore ? (
      <StreamSearchLoadMoreButton
        isLoading={isLoading}
        onLoadMore={onLoadMore}
        loadingLabel={loadingLabel}
        label={label}
        disabled={disabled}
      />
    ) : null}
  </>
);

export const SearchResultContent = memo(SearchResultContentRaw);
SearchResultContent.displayName = "SearchResultContent";
